import {
  Directive,
  inject,
  Injector,
  input,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { TopNavigationSlotsService } from './top-navigation-slots.service';

@Directive({
  selector: '[topNavigationSlot]',
  standalone: true,
})
export class TopNavigationSlotDirective implements OnInit, OnDestroy {
  readonly navSlotsSvc = inject(TopNavigationSlotsService);
  readonly template = inject(TemplateRef);
  readonly injector = inject(Injector);

  readonly slot = input.required<'start' | 'end'>({
    alias: 'topNavigationSlot',
  });
  readonly contextInjector = input<Injector>(null, {
    alias: 'topNavigationSlotInjector',
  });

  ngOnInit(): void {
    this.navSlotsSvc.setSlot(
      this.slot(),
      this.template,
      this.contextInjector() ?? this.injector,
    );
  }

  ngOnDestroy(): void {
    this.navSlotsSvc.setSlot(this.slot());
  }
}
